var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectAllIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.29476 2H18.3581C19.6202 2 20.6529 3.03264 20.6529 4.29476V5.44215L18.3581 7.73691V4.29476H2.29476V20.3581H18.3581V11.1791L20.6529 8.88429V20.3581C20.6529 21.6202 19.6202 22.6529 18.3581 22.6529H2.29476C1.03264 22.6529 0 21.6202 0 20.3581V4.29476C0 3.03264 1.03264 2 2.29476 2Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8063 2.99905C21.385 2.44129 22.3012 2.44094 22.8805 2.99825C23.4917 3.5864 23.4918 4.56471 22.8806 5.15294L10.1566 17.3992C9.77076 17.7705 9.16089 17.772 8.77324 17.4026L4.48595 13.3167C3.86652 12.7264 3.86764 11.7377 4.48843 11.1487C5.06622 10.6006 5.97219 10.6013 6.54911 11.1504L9.46654 13.9269L20.8063 2.99905Z",
    fill: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAllIcon);
export default __webpack_public_path__ + "static/media/select-all-icon.ab97f713.svg";
export { ForwardRef as ReactComponent };